import { createContext, useContext, useState, ReactNode } from "react";

interface EntityUpdateContextType {
  hasActiveEntityUpdates: boolean;
  setHasActiveEntityUpdates: (hasUpdates: boolean) => void;
}

const EntityUpdateContext = createContext<EntityUpdateContextType | undefined>(undefined);

interface EntityUpdateProviderProps {
  children: ReactNode;
}

export const EntityUpdateProvider = ({ children }: EntityUpdateProviderProps) => {
  const [hasActiveEntityUpdates, setHasActiveEntityUpdates] = useState<boolean>(false);

  return (
    <EntityUpdateContext.Provider value={{ hasActiveEntityUpdates, setHasActiveEntityUpdates }}>
      {children}
    </EntityUpdateContext.Provider>
  );
};

export const useEntityUpdate = (): EntityUpdateContextType => {
  const context = useContext(EntityUpdateContext);
  if (context === undefined) {
    throw new Error("useEntityUpdate must be used within an EntityUpdateProvider");
  }
  return context;
};
